module.exports = __webpack_public_path__ + "img/diabetesvic.fd4d321.png";